// import SelectFiled from '../select-field/SelectField';

type Option = {
  value: string | number;
  label: string;
};

interface CustomPhoneNumberProperties {
  inputLabel?: string;
  placeholder: string;
  value: string;
  name: string;
  onChangeValue: (name: string, value: string | number) => void;
  countryCode: string;
  listOfCountryCode?: Option[] | null;
  valueRequired?: boolean;
  readOnly?: boolean;
  error?: boolean;
  errorMessage?: string;
}

/**
 * Function to handle phone number input with select country code
 * @param {any} param0 - The param0
 * @param {any} param0.inputLabel - The inputLabel prop
 * @param {any} param0.name - The name prop
 * @param {any} param0.placeholder - The placeholder prop
 * @param {any} param0.value - The value prop
 * @param {any} param0.onChangeValue - The onChangeValue prop
 * @param {any} param0.countryCode - The countryCode prop
 * @param {any} param0.listOfCountryCode - The listOfCountryCode prop
 * @param {any} param0.valueRequired - The valueRequired prop
 * @param {any} param0.readOnly - The readOnly prop
 * @param {any} param0.error - The error prop
 * @param {any} param0.errorMessage - The errorMessage prop
 */
function CustomPhoneNumber({
  inputLabel,
  name,
  placeholder,
  value,
  onChangeValue,
  countryCode,
  listOfCountryCode,
  valueRequired,
  readOnly,
  error,
  errorMessage,
}: CustomPhoneNumberProperties) {
  const countryListToShow = listOfCountryCode || [
    {
      label: '+1',
      value: '1',
    },
    {
      label: '+91',
      value: '91',
    },
    {
      label: '+966',
      value: '966',
    },
    {
      label: '+971',
      value: '971',
    },
  ];
  /**
   * handle country code change or phone number change
   * @param {any} changeName - The changeName
   * @param {any} changeValue - The changeValue
   */
  const handleValueChange = (changeName: string, changeValue: string) => {
    if (changeName === 'countryCode' || changeValue.length <= 15) {
      onChangeValue(changeName, changeValue);
    }
  };

  return (
    <div className="custom-phone-number-wrap">
      {inputLabel && (
        <p className={`input-label ${error && 'error'}`}>
          {inputLabel}
          {valueRequired && <span>*</span>}
        </p>
      )}
      <div className={`custom-phone-number-container ${error && 'error'}`}>
        {/* <SelectFiled
          inputLabel=""
          name="countryCode"
          selectedValue={countryCode}
          onChangeValue={handleValueChange}
          options={listOfCountryCode || countryListToShow}
          readOnly={readOnly}
        /> */}
        <select
          className="custom-phone-number-container-select"
          value={countryCode}
          onChange={(event) => handleValueChange('countryCode', event.target.value)}>
          {countryListToShow?.map((option) => (
            <option key={option?.value} value={option?.value} disabled={readOnly}>
              {option?.label}
            </option>
          ))}
        </select>
        <input
          type="number"
          placeholder={placeholder}
          value={value !== null ? value : undefined}
          onChange={(event) => handleValueChange(name, event.target.value)}
          required={valueRequired}
          readOnly={readOnly}
        />
      </div>
      {error && <p className="custom-input-error-message">{errorMessage}</p>}
    </div>
  );
}

CustomPhoneNumber.defaultProps = {
  inputLabel: '',
  valueRequired: false,
  readOnly: false,
  error: false,
  errorMessage: '',
  listOfCountryCode: null,
};

export default CustomPhoneNumber;
